<script lang="ts">
  export let text: string;
  export let variant: "green" | "orange" = "orange" ;

  // required for CSS compilation
  const colorVariants = {
    orange: 'bg-orange-300',
    green: 'bg-green-300',
  }
</script>

<span class={`inline-flex items-center h-6 px-2 text-xs normal-case rounded-md text-stone-800 ${colorVariants[variant]}`}>
  {text}
</span>
